export const AUTHENTICATED = 'components/login/AUTHENTICATED';

export const authenticated = () => ({
  type: AUTHENTICATED,
});
